import { Option } from 'types/Generics';

/**
 * Formats a time in 12-hour format with AM/PM
 * @param hour - Hour in 24-hour format (0-23)
 * @param minute - Minute (0-59)
 * @returns Formatted time string (e.g., "8:00am", "11:30pm")
 */
const formatTime12Hour = (hour: number, minute: number): string => {
    const period = hour >= 12 ? 'pm' : 'am';
    const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    const minuteStr = minute.toString().padStart(2, '0');

    return `${hour12}:${minuteStr}${period}`;
};

/**
 * Generates time options in 15-minute intervals for a 24-hour period
 * @returns Array of time options from 12:00am to 11:45pm
 */
export const generateTimeOptions = (): Option<string>[] => {
    const times: Option<string>[] = [];

    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
            const hourStr = hour.toString().padStart(2, '0');
            const minuteStr = minute.toString().padStart(2, '0');
            const timeStr = `${hourStr}:${minuteStr}`;
            const displayName = formatTime12Hour(hour, minute);

            times.push({
                id: timeStr,
                name: displayName
            });
        }
    }

    return times;
};

/**
 * Generates time options in specified minute intervals
 * @param intervalMinutes - The interval in minutes (e.g., 15, 30, 60)
 * @returns Array of time options
 */
export const generateTimeOptionsWithInterval = (intervalMinutes: number): Option<string>[] => {
    const times: Option<string>[] = [];

    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += intervalMinutes) {
            const hourStr = hour.toString().padStart(2, '0');
            const minuteStr = minute.toString().padStart(2, '0');
            const timeStr = `${hourStr}:${minuteStr}`;
            const displayName = formatTime12Hour(hour, minute);

            times.push({
                id: timeStr,
                name: displayName
            });
        }
    }

    return times;
};
